module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC0SURBVHgB7ZHBDcIwDEXtskjYAIkJmAhGgYmYAIkNyCJg7LaHqnKa2DnW75LUtf1fVYAgCIK9g1rxfKWPnF+Ey/uOGTo43SgdCJ5yfz3wuH4/aEM0HeOgLID+8ESFHlXgx1/OA7lHYhWeZafWh1sLBl7ADYkfs+V3aOGlWawtskpYwqsCVglreJNAq4QnvFmgJuENNwmUJKTuDTcLaBJz2RXuElAkwBvuFlhKyN0bHgRBEAh/ucSdy1URQnkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shang.png
// module id = 5tqD
// module chunks = 0